<template>
  <!--
    MinimizedCellLite - lite-замена q-expansion-item для свёрнутых ячеек.
    Для несвёрнутых ячеек (minimized=false) рендерит слот НАПРЯМУЮ без обёртки,
    чтобы не менять DOM и не ломать существующую вёрстку/измерения высот.
    Для свёрнутых - плоский аккордеон: заголовок "Элементов: N" + раскрытие по клику.
  -->
  <template v-if="minimized">
    <button type="button" class="qtl-min__toggle" @click.stop="open = !open">
      <span class="qtl-min__chevron" :class="{ 'qtl-min__chevron--open': open }">▾</span>
      <span class="qtl-min__label">{{ t('items') }}: {{ count }}</span>
    </button>
    <div v-show="open" class="qtl-min__body">
      <slot />
    </div>
  </template>
  <slot v-else />
</template>

<script setup lang="ts">
import { ref } from "vue";
import { i18n } from "@/i18n";

defineProps<{
  minimized: boolean;
  count: number;
}>();

const t = (k: string) => i18n.global.t(k);
const open = ref(false);
</script>

<style lang="scss" scoped>
.qtl-min__toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px 0;
  color: #555;
  font-size: 13px;
}

.qtl-min__toggle:hover {
  color: #333333;
}

.qtl-min__chevron {
  display: inline-block;
  transition: transform 0.12s ease;
  transform: rotate(-90deg);
  font-size: 12px;
  line-height: 1;
}

.qtl-min__chevron--open {
  transform: rotate(0deg);
}

.qtl-min__label {
  white-space: nowrap;
}

.qtl-min__body {
  padding: 2px 0 0 0;
}
</style>
